import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { GradeBadge, PaceFlag, StatusChip } from "@/components/Badges";
import { Link } from "react-router-dom";

export default function LiveBoard() {
  const { t } = useLang();
  const [looms, setLooms] = useState([]);
  const [zone, setZone] = useState("");
  const [flag, setFlag] = useState("");

  useEffect(() => {
    const params = {};
    if (zone) params.zone = zone;
    api.get("/looms", { params }).then((r) => {
      let data = r.data;
      if (flag) {
        // pace flag comes from PO, we need to enrich
      }
      setLooms(data);
    });
  }, [zone, flag]);

  const sorted = [...looms].sort((a, b) => {
    // Stopped/red first
    const s = (x) => (x.status === "Stopped" ? 0 : x.last_grade === "C" ? 1 : x.last_grade === "B" ? 2 : 3);
    return s(a) - s(b);
  });

  return (
    <div>
      <div className="eyebrow">{t("nav_live_board")}</div>
      <h1 className="text-2xl font-bold" style={{ color: "var(--brand-navy)" }}>{t("active_looms")}</h1>
      <div className="flex gap-2 mt-2">
        <select data-testid="zone-filter" value={zone} onChange={(e) => setZone(e.target.value)} className="h-10 border border-[#1B3A5C]/15 rounded-md px-2 text-sm">
          <option value="">All zones</option>
          <option value="A">Zone A</option>
          <option value="B">Zone B</option>
          <option value="C">Zone C</option>
        </select>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 mt-4">
        {sorted.map((l) => (
          <div key={l.id} data-testid={`live-card-${l.loom_number}`} className="hag-surface p-3">
            <div className="flex items-center justify-between">
              <div className="font-bold text-lg" style={{ color: "var(--brand-navy)" }}>{l.loom_number}</div>
              <div className="flex gap-1"><StatusChip status={l.status} /><GradeBadge grade={l.last_grade} /></div>
            </div>
            <div className="text-sm">{l.weaver_name}</div>
            <div className="text-xs text-[#7C8E9E]">{l.village} · Zone {l.zone || "?"}</div>
            {l.current_po_id && (
              <Link to={`/po/${l.current_po_id}`} className="text-xs mt-2 inline-block underline text-[#1B3A5C]">PO details →</Link>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
